// @ts-nocheck
import React from "react";
import { Outlet, Link } from "react-router-dom";
import { AppShell } from "@/components/shell/AppShell";
import { staffNav, staffFooterNav } from "@/config/staffNav";
import AreaUserMenu from "@/components/common/AreaUserMenu";
import ModuleGuard from "@/components/common/ModuleGuard";

import { RecruitLookLogo } from "@/components/ui/logo";
import { useSubdomainBranding } from "@/hooks/useSubdomainBranding";

/**
 * Layout for STAFF users. Reuses the shared AppShell with the minimal staff nav.
 * Brand slot = RLevents logo, or the org logo when on a white-label subdomain
 * (resolved via useSubdomainBranding). No platform/admin/coach/org nav exposed.
 */
const StaffHomeLayout: React.FC = () => {
  const { branding } = useSubdomainBranding();
  const [logoFailed, setLogoFailed] = React.useState(false);

  const orgLogo = branding && !branding.is_recruitlook_branded ? branding.logo_url : null;
  const showOrgLogo = orgLogo && !logoFailed;

  const brand = (
    <Link to="/staff/home" className="flex items-center gap-2 overflow-hidden">
      {showOrgLogo ? (
        <img
          src={orgLogo}
          alt={`${branding?.org_name ?? "Organization"} logo`}
          className="h-7 w-auto max-w-[140px] shrink-0 object-contain group-data-[collapsible=icon]:max-w-[28px]"
          onError={() => setLogoFailed(true)}
        />
      ) : (
        <RecruitLookLogo size="sm" />
      )}
    </Link>
  );

  return (
    <AppShell
      navGroups={staffNav}
      footerNav={staffFooterNav}
      brand={brand}
      userMenu={<AreaUserMenu roleLabel="Staff" settingsPath="/account" />}
    >
      <div className="mx-auto w-full max-w-3xl px-4 py-6 sm:px-6 sm:py-8">
        <ModuleGuard module="staff_portal" redirectTo="/">
          <Outlet />
        </ModuleGuard>
      </div>

    </AppShell>
  );
};

export default StaffHomeLayout;
